import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeMinuteRequestLineDTO, UpdateMinuteRequestLineApiDTO } from '../../minutes/interface/minute-request.interface';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-change-minute-request-line-modal',
  templateUrl: './change-minute-request-line-modal.component.html',
  styleUrls: ['./change-minute-request-line-modal.component.scss']
})
export class ChangeMinuteRequestLineModalComponent implements OnInit {

  requestedLine = new FormControl('', [
    Validators.required, Validators.min(1)
  ])

  constructor(@Inject(MAT_DIALOG_DATA)public data: ChangeMinuteRequestLineDTO,
    public dialogRef: MatDialogRef<ChangeMinuteRequestLineModalComponent>)
  {

  }

  ngOnInit(): void {
      
  }

  public sendMinuteLineUpdate(){
    const line: number = Number(this.requestedLine.value);
    const requestToApi: UpdateMinuteRequestLineApiDTO = {
      newLine: line,
      minuteRequestId: this.data.minuteRequestId,
      lineType: this.data.lineType
    };
    this.dialogRef.close(requestToApi);
  }
}
